import Vue from 'vue'
import { bugsnagClient } from '@common/utils'
import bugsnagVue from '@bugsnag/plugin-vue'

if (bugsnagClient) {
  bugsnagClient.use(bugsnagVue, Vue)
}
